export default {
  translation: {
    common: {
      save: 'Simpan',
      cancel: 'Batal',
      delete: 'Hapus',
      edit: 'Edit',
      add: 'Tambah',
      search: 'Cari',
      loading: 'Memuat...',
      success: 'Berhasil',
      error: 'Error',
      confirm: 'Konfirmasi',
      yes: 'Ya',
      no: 'Tidak',
      back: 'Kembali',
      next: 'Selanjutnya',
      submit: 'Kirim',
      close: 'Tutup',
      required: 'Wajib',
      optional: 'Opsional',
    },
    auth: {
      login: 'Masuk',
      logout: 'Keluar',
      register: 'Daftar',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Konfirmasi Password',
      forgotPassword: 'Lupa Password?',
      resetPassword: 'Reset Password',
      loginSuccess: 'Berhasil masuk',
      logoutSuccess: 'Berhasil keluar',
      invalidCredentials: 'Email atau password salah',
      emailSent: 'Email reset password telah dikirim',
    },
    household: {
      title: 'Rumah Tangga',
      createHousehold: 'Buat Rumah Tangga',
      householdName: 'Nama Rumah Tangga',
      householdAddress: 'Alamat',
      members: 'Anggota',
      addMember: 'Tambah Anggota',
      removeMember: 'Hapus Anggota',
      switchHousehold: 'Ganti Rumah Tangga',
      currentHousehold: 'Rumah Tangga Saat Ini',
      noHousehold: 'Tidak ada rumah tangga',
    },
    task: {
      title: 'Tugas',
      createTask: 'Buat Tugas',
      taskTitle: 'Judul',
      description: 'Deskripsi',
      dueDate: 'Tanggal Jatuh Tempo',
      priority: 'Prioritas',
      status: 'Status',
      category: 'Kategori',
      assignTo: 'Tugaskan ke',
      startTask: 'Mulai',
      finishTask: 'Selesaikan',
      completeTask: 'Selesai',
      cancelTask: 'Batalkan',
      taskStarted: 'Tugas dimulai',
      taskFinished: 'Tugas selesai',
      taskCompleted: 'Tugas telah selesai',
      taskCancelled: 'Tugas dibatalkan',
      highPriority: 'Tinggi',
      mediumPriority: 'Sedang',
      lowPriority: 'Rendah',
      pending: 'Menunggu',
      inProgress: 'Sedang Berjalan',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
    },
    expense: {
      title: 'Pengeluaran',
      createExpense: 'Tambah Pengeluaran',
      amount: 'Jumlah',
      category: 'Kategori',
      date: 'Tanggal',
      description: 'Deskripsi',
      receipt: 'Resi',
      verify: 'Verifikasi',
      verified: 'Terverifikasi',
      pending: 'Menunggu',
      rejected: 'Ditolak',
    },
    quotation: {
      title: 'Penawaran',
      createQuotation: 'Buat Penawaran',
      vendor: 'Vendor',
      totalAmount: 'Total Jumlah',
      validUntil: 'Berlaku Hingga',
      approve: 'Setujui',
      reject: 'Tolak',
      approved: 'Disetujui',
      rejected: 'Ditolak',
      pending: 'Menunggu',
    },
    mealPlan: {
      title: 'Rencana Makan',
      createMealPlan: 'Buat Rencana Makan',
      date: 'Tanggal',
      mealType: 'Jenis Makanan',
      breakfast: 'Sarapan',
      lunch: 'Makan Siang',
      dinner: 'Makan Malam',
      snack: 'Camilan',
      approve: 'Setujui',
      reject: 'Tolak',
      aiRecommend: 'Rekomendasi AI',
    },
    notification: {
      title: 'Notifikasi',
      markAsRead: 'Tandai Dibaca',
      markAllRead: 'Tandai Semua Dibaca',
      noNotifications: 'Tidak ada notifikasi',
      taskReminder: 'Pengingat Tugas',
      expenseApproved: 'Pengeluaran Disetujui',
      quotationApproved: 'Penawaran Disetujui',
    },
    settings: {
      title: 'Pengaturan',
      language: 'Bahasa',
      theme: 'Tema',
      notifications: 'Notifikasi',
      account: 'Akun',
      privacy: 'Privasi',
      about: 'Tentang',
      version: 'Versi',
      logout: 'Keluar',
    },
    role: {
      employer: 'Pemberi Kerja',
      maid: 'Pembantu',
      familyMember: 'Anggota Keluarga',
      admin: 'Admin',
    },
    backup: {
      title: 'Backup & Pulihkan',
      createBackup: 'Buat Backup',
      restoreBackup: 'Pulihkan Backup',
      lastBackup: 'Backup Terakhir',
      backupSuccess: 'Backup berhasil',
      restoreSuccess: 'Pemulihan berhasil',
    },
    export: {
      title: 'Ekspor',
      exportCSV: 'Ekspor sebagai CSV',
      exportPDF: 'Ekspor sebagai PDF',
      exportJSON: 'Ekspor sebagai JSON',
      exportSuccess: 'Ekspor berhasil',
    },
  },
}
